export function makeGeneratedAppSpecificPassword(generatedAppSpecificPassword) {
  return generatedAppSpecificPassword;
}